<template>
	<div
		:style="{
			position: 'absolute',
			left: clientCoordinates.clientX,
			top: 0,
		}"
	>
		<p>{{ clientCoordinates.clientX }}</p>
		<p>{{ clientCoordinates.clientX }}</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
		<p>line 1</p>
	</div>
</template>

<script>
export default {
	name: 'info',
	props: {
		clientCoordinates: Object,
	},
};
</script>
